// API Configuration
// window.env is populated at runtime by server.js (production); process.env is baked in at build time (dev).
const _runtimeEnv = typeof window !== 'undefined' ? (window as any).env || {} : {};

export const API_BASE_URL =
  _runtimeEnv.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_API_BASE_URL ||
  'http://localhost:8085/apmt-cdh-query-service';

export const DB_SERVICE_BASE_URL =
  _runtimeEnv.REACT_APP_DB_SERVICE_BASE_URL ||
  process.env.REACT_APP_DB_SERVICE_BASE_URL ||
  'http://localhost:8084/apmt-cdh-db-service';

export const QUERY_ACTIONS_BASE_URL =
  _runtimeEnv.REACT_APP_QUERY_ACTIONS_BASE_URL ||
  process.env.REACT_APP_QUERY_ACTIONS_BASE_URL

export const QUERY_EXECUTE_BASE_URL =
  _runtimeEnv.REACT_APP_QUERY_EXECUTE_BASE_URL ||
  process.env.REACT_APP_QUERY_EXECUTE_BASE_URL ||
  'https://api.apmterminals.com/portsight/v1';

// Standalone apmt-cdh-reference-data-service. Base already includes the /api/v1 prefix,
// so callers pass paths like `/{terminal}/{app}/schemas`.
export const REF_DATA_API_BASE =
  _runtimeEnv.REACT_APP_REF_DATA_API_BASE ||
  process.env.REACT_APP_REF_DATA_API_BASE ||
  'http://localhost:8087/api/v1';

console.log('[ApiConfig] API_BASE_URL:', API_BASE_URL);
console.log('[ApiConfig] REF_DATA_API_BASE:', REF_DATA_API_BASE);
console.log('[ApiConfig] QUERY_ACTIONS_BASE_URL:', QUERY_ACTIONS_BASE_URL);
console.log('[ApiConfig] QUERY_EXECUTE_BASE_URL:', QUERY_EXECUTE_BASE_URL);

export const API_ENDPOINTS = {
  // Query Management
  queries: '/queries',
  queryById: (id: string) => `/queries/${id}`,
  queryExecute: (id: string) => `/queries/${id}/execute`,
  queryExecuteVersion: (id: string, version: string) => `/queries/${id}/versions/${version}/execute`,
  // Oracle execution (DB Service)
  queryExecuteOracle: (id: string) => `/queries/${id}/execute`,
  queryExecuteVersionOracle: (id: string, version: string) => `/queries/${id}/versions/${version}/execute`,
  queryActivation: (id: string) => `/queries/${id}/activation`,
  queryVersions: (id: string) => `/queries/${id}/versions`,
  queryVersionHistory: (id: string) => `/queries/${id}/versions/history`,
  queryVersionSetCurrent: (id: string, version: string) => `/queries/${id}/versions/${version}/set-current`,
  querySearch: '/queries/search',
  categoryCounts: '/queries/stats/categories',

  // Query Validation
  validate: '/queries/advanced/validate',

  // Query Scheduling
  schedule: '/queries/advanced/schedule',
  schedules: '/queries/advanced/schedules',
  scheduleById: (id: string) => `/queries/advanced/schedules/${id}`,
  checkScheduleAvailability: '/queries/advanced/schedules/check-availability',
  terminalConfigs: '/terminals/configs',
  terminalConfigById: (id: string) => `/terminals/${id}/config`,

  // AI Features
  optimize: '/queries/advanced/optimize',
  generate: '/queries/advanced/generate',
  generateMetadata: '/queries/advanced/generate-metadata',

  // Results
  results: '/query-results',
  resultsByTable: (tableName: string) => `/query-results/${tableName}`,

  // Health
  health: '/actuator/health',

  // Schema Exploration
  schemaExplore: '/api/v1/schema/explore',

  // Data
  data: '/data',

  // Reference Data
  applications: '/applications',
};

export default API_BASE_URL;
